/**
 * @file Точка входа приложения мембраны
 * @module membrane/src/main
 * 
 * Инициализирует React-приложение и монтирует корневой компонент Membrane.
 * Мембрана - это многослойный интерфейс между Полем (будущим) и миром (настоящим).
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

